export default defineAppConfig({
  ui: {
    colors: {
      primary: 'sky',
      neutral: 'zinc'
    },
    // The stock xs/sm badges render 8px/10px text, unreadable on a phone.
    badge: {
      variants: {
        size: {
          xs: { base: 'text-xs/4' },
          sm: { base: 'text-xs/4' }
        }
      }
    }
  },
  features: {
    // Homepage testimonials section — re-enabled 2026-06-12 (was hidden per
    // UAT review #9); flip to hide without code changes.
    homepageTestimonials: true
  }
})
